import React, { useState, useEffect } from "react";
import { FaExchangeAlt, FaSpinner } from "react-icons/fa";
import "../../Complaint.css";
import "bootstrap/dist/css/bootstrap.min.css";
import CommonContainer from "../Container/CommonContainer";
import toast from "react-hot-toast";
import * as ReportServices from "../../Services/Reports/ReportServices";
import { store } from "../../Store/store";
import { LoadingMessage } from "../../Common/CommonVariables";

const SOAReportComponent = () => {
  const [loading, setLoading] = useState(false);
  const [soaReportList, setSOAReportList] = useState(null);
  const [selectedFiscalYear, setSelectedFiscalYear] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");

  const userInfo = store.getState();
  const userData = userInfo?.userData || {};

  const currentYear = new Date().getFullYear();
  const nextYear = currentYear + 1;
  const defaultFiscalYear = `${currentYear}-${nextYear}`;

  const fiscalYears = [
    `${currentYear - 2}-${currentYear - 1}`,
    `${currentYear - 1}-${currentYear}`,
    defaultFiscalYear,
  ];

  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  const getPreviousMonthLabel = () => {
    const index = new Date().getMonth() - 1;
    return months[(index + 12) % 12];
  };

  const downloadSOAReport = (fiscalYear = selectedFiscalYear, month = selectedMonth) => {
    if (!userData.Partner_Code) {
      toast.error("No account is mapped to get report");
      return;
    }

    if (!fiscalYear || !month) {
      toast.error("Please select both Fiscal Year and Month.");
      return;
    }

    setLoading(true);

    const fiscalYearParts = fiscalYear.split("-");
    const fiscalYearFormatted = `FY${fiscalYearParts[0].slice(-2)}-${fiscalYearParts[1].slice(-2)}`;

    const requestData = {
      clientCode: userData.Partner_Code,
      soaYear: fiscalYearFormatted,
      soaMonth: month,
    };

    ReportServices.GetMonthlySOAReport(requestData)
      .then(({ data }) => {
        if (data.IsSuccess) {
          setSOAReportList(data.Data || null);
        } else {
          setSOAReportList(null);
        }
      })
      .catch(() => {
        setSOAReportList(null);
        toast.error("Something went wrong.");
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    const fy = defaultFiscalYear;
    const month = getPreviousMonthLabel();
    setSelectedFiscalYear(fy);
    setSelectedMonth(month);

    if (userData.Partner_Code) {
      downloadSOAReport(fy, month);
    }
  }, []);

  return (
    <CommonContainer icon={<FaExchangeAlt size={20}/>} heading="SOA Monthly Report">
      <div className="d-flex flex-column flex-sm-row custom-soa-wrapper mb-2 align-items-lg-center w-100 custom-soa-tablet">
        {/* Fiscal Year */}
        <div className="d-flex flex-column flex-md-row align-items-md-center custom-soa-field">
          <label className="m-0">Fiscal Year:</label>
          <select
            className="form-control custom-soa-select"
            value={selectedFiscalYear}
            onChange={(e) => setSelectedFiscalYear(e.target.value)}
            style={{ width: "160px" }}
          >
            {fiscalYears.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>

        {/* Month */}
        <div className="d-flex flex-column flex-md-row align-items-md-center custom-soa-field">
          <label className="m-0">Month:</label>
          <select
            className="form-control custom-soa-select"
            value={selectedMonth}
            onChange={(e) => setSelectedMonth(e.target.value)}
            style={{ width: "160px" }}
          >
            <option value="">Select Month</option>
            {months.map((month) => (
              <option key={month} value={month}>
                {month}
              </option>
            ))}
          </select>
        </div>

        {/* Search Button */}
        {/* <button
          className="btn btn-success d-flex align-items-center justify-content-center"
          style={{ height: "35px", padding: "0 8px" }}
          onClick={() => downloadSOAReport()}
          disabled={loading}
        >
          {loading ?
           <FaSpinner className="fa-spin" />
            : <b>GO</b>}
        </button> */}

         <button
          className="btn custom-sumbitbtn custom-soa-submit d-flex align-items-center justify-content-center p-1 invoice-report-search-btn"
          style={{ height: "35px", padding: "0" }}
          onClick={() => downloadSOAReport()}
          disabled={loading}
        >
          {loading ? <FaSpinner className="fa-spin" /> : <b>GO</b>}
        </button>


        {loading && <LoadingMessage />}
      </div>

      {/* Report Card Display */}
      {soaReportList ? (
        <div className="card p-3 shadow-sm mb-3">
          {/* <div className="row mb-2">
            <div className="col-md-6">
              <strong>Client Name:</strong> {soaReportList.ClientName || "N/A"}
            </div>
            <div className="col-md-6">
              <strong>Client Code:</strong> {soaReportList.clientCode || "N/A"}
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-md-6">
              <strong>Email:</strong> {soaReportList.InvoicingEmail || "N/A"}
            </div>
            <div className="col-md-6">
              <strong>Mobile:</strong> {soaReportList.MobileNumber || "N/A"}
            </div>
          </div> */}

          {soaReportList.pdflinkforMonthlySOA ? (
            <div className="mt-3">
              <iframe
                src={soaReportList.pdflinkforMonthlySOA}
                title="SOA PDF"
                width="100%"
                height="600px"
                style={{ border: "1px solid #ccc", borderRadius: "8px" }}
              />
            </div>
          ) : (
            <div className="text-muted text-center mt-3">
              No PDF available for this month.
            </div>
          )}
        </div>
      ) : (
        <div className="text-center text-muted mt-4">
         {/* {loading ? <>loading.....</> :"No report found for selected duration"} */}
         No report found for selected duration
        </div>
      )}
    </CommonContainer>
  );
};

export default SOAReportComponent;
